<div class="histograms-encoding-builder">
  <ng-template
    let-field="field"
    let-channel="channel"
    let-viewSource="viewSource"
    let-modeView="modeView"
    let-allowScalars="allowScalars"
    let-allowDiscrete="allowDiscrete"
    let-allowContinuous="allowContinuous"
    #dragAndDrop
  >
    <mode-encoding-field-single
      (remove)="removeField($event)"
      [encoding]="encoding"
      [field]="field"
      [fieldFormatMap]="fieldFormatMap$ | async"
      [format]="format"
      [model]="model"
      [view]="modeView"
      [viewName]="viewSource"
      [vizToken]="vizToken$ | async"
      [chartType]="chartType"
      [allowScalars]="allowScalars"
      [allowAggregates]="true"
      [allowDiscrete]="allowDiscrete"
      [allowContinuous]="allowContinuous"
      [hideAllMenuOptions]="true"
    ></mode-encoding-field-single>
  </ng-template>

  <div class="encoding-zone-container">
    <div class="zone margin-bottom-medium">
      <mode-encoding-dropzone
        data-test="column-dropzone"
        [header]="'X-Axis (Columns)'"
        [channel]="'column'"
        [isDraggable]="isDragging()"
        [placeholderClasses]="true"
        [fields]="columns"
        [template]="dragAndDrop"
        [viewSource]="queryToken$ | async"
        [view]="view$ | async"
        [isMetrics]="false"
        [allowDiscrete]="false"
        [allowContinuous]="true"
        [allowScalars]="true"
        [chartType]="chartType"
        [dragField]="dragInfo"
        [typeAheadShouldReplace]="true"
        (dropField)="onDrop($event)"
        (dragStart)="onDragStart($event)"
        (dragEnd)="onDragEnd($event)"
        (fieldDropOnField)="onFieldDrop()"
      ></mode-encoding-dropzone>
    </div>
  </div>

  <mode-bin-settings-quick-charts
    [binSize]="binSize"
    [suggestedBinSize]="suggestedBinSize"
    [isLoading]="isLoading$ | async"
    [showRecommendedBinSize]="encoding.x.length"
    [disableUseRecommended]="!encoding.x.length || disableUseRecommended"
    (binningDetails)="handleBinSizeUpdate($event)"
  ></mode-bin-settings-quick-charts>

  <div class="palette-selector">
    <mode-color-swatch-flyout
      class="flyout-container"
      customIcon="illo-mini-mark-color"
      [updateOnMove]="false"
      [activeColor]="activeColor"
      [selectedColorPalette]="selectedColorPalette"
      [allColorPalettes]="allColorPalettes"
      (colorUpdated)="onColorSwatchFlyoutUpdated($event.colorSelected, $event.selectedPalette)"
    ></mode-color-swatch-flyout>
    <span class="header">Colors</span>
  </div>
</div>
